import PropTypes from 'prop-types';
import React from 'react';
import TreeView from 'react-treeview';
import ParticipationLabel from './ParticipationLabel.jsx';

class ParticipationsTree extends React.Component {
  renderNode = (initiativeParticipation) => {
    const {
      typeParticipating,
      isPreview,
      initiative,
      activeInitiativeParticipationId,
      status,
      sentiment,
      handleResetSearch,
    } = this.props;

    const nodeLabel = (
      <ParticipationLabel
        typeParticipating={typeParticipating}
        isPreview={isPreview}
        initiative={initiative}
        initiativeParticipation={initiativeParticipation}
        isActive={
          initiativeParticipation.id === activeInitiativeParticipationId
        }
        status={status}
        sentiment={sentiment}
        showOutlineBox={initiativeParticipation.parentId === null}
        handleResetSearch={handleResetSearch}
      />
    );

    if (
      initiativeParticipation.leavesCount === 0 ||
      (initiativeParticipation.participantType === 'individual' &&
        initiativeParticipation.parentId)
    ) {
      return null;
    }

    if (initiativeParticipation.children.length === 0) {
      return (
        <div key={initiativeParticipation.id} className="tree-view_leaf">
          {nodeLabel}
        </div>
      );
    }

    return (
      <TreeView key={initiativeParticipation.id} nodeLabel={nodeLabel}>
        {initiativeParticipation.children.map(this.renderNode)}
      </TreeView>
    );
  };

  render() {
    const {
      typeParticipating,
      isPreview,
      organization,
      initiative,
      initiativeParticipations,
      activeInitiativeParticipationId,
      status,
      sentiment,
      handleSearch,
    } = this.props;

    const rootNodeLabel = (
      <ParticipationLabel
        typeParticipating={typeParticipating}
        isPreview={isPreview}
        initiative={initiative}
        isActive={activeInitiativeParticipationId === null}
        label={organization.name}
        status={status}
        sentiment={sentiment}
        showOutlineBox
        handleSearch={handleSearch}
      />
    );

    return (
      <TreeView nodeLabel={rootNodeLabel}>
        {initiativeParticipations.map(this.renderNode)}
      </TreeView>
    );
  }
}

const participationPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  parentId: PropTypes.number,
  label: PropTypes.string.isRequired,
});

participationPropType.children = PropTypes.arrayOf(participationPropType);

export default ParticipationsTree;
